export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            关于我们
          </h2>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              <strong className="text-primary-600">虫虫动漫</strong>诞生于对漫画的热爱。我们是一群资深的漫画爱好者，深知漫友们在寻找漫画全集资源时的痛点——翻页繁复、加载缓慢、资源分散。于是我们打造了这个专注于<strong>漫画全集免费在线阅读</strong>的平台。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              虫虫动漫的核心特色是<strong>下拉式阅读</strong>模式。告别传统翻页漫画网站的割裂感，我们将整卷或整章漫画在一个页面内连续展示，读者只需自然下滑即可流畅阅读，真正实现<strong>一次性看完全卷完结漫画</strong>。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              目前平台已收录海量<strong>漫画完整版</strong>资源，涵盖热血、修仙、恋爱、悬疑、搞笑、玄幻等数十种类型。无论是追新番还是补经典，虫虫动漫都是你值得信赖的<strong>漫画大全</strong>平台。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              我们始终坚持<strong>免费、纯净、高品质</strong>的运营理念。不设置付费墙，不插入干扰广告，持续优化阅读体验。虫虫动漫——让每一个热爱漫画的人都能轻松享受完整故事。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}